import { Trans } from "@web-monorepo/i18n/macro";
import { DDSBodyText, DDSButton } from "@web-monorepo/dds";
import { Link } from "react-router-dom";
import DefaultVideo from "src/pods/ideas/components/video/Video";
import { Slide } from "src/pods/ideas/data/types";
import DefaultNoWebkitOverflowScrolling from "./NoWebkitOverflowScrolling";
import styles from "./PhoneWatchVideo.module.css";

type PhoneWatchVideoProps = {
  watch: Slide;
  canPlayOnComputer?: boolean;
  onPlayOnComputer: VoidFunction;
  /**
   * Dependency injection for testability: Storybook stories pass stubs for
   * `Video` (avoids the RadiantMP browser dependency) and
   * `NoWebkitOverflowScrolling` (sidesteps the document-mutating lifecycle).
   * Production callers leave these undefined.
   */
  di?: {
    Video?: React.ComponentType<React.ComponentProps<typeof DefaultVideo>>;
    NoWebkitOverflowScrolling?: React.ComponentType<React.ComponentProps<typeof DefaultNoWebkitOverflowScrolling>>;
  };
};

function PhoneWatchVideo({ watch, canPlayOnComputer, onPlayOnComputer, di }: PhoneWatchVideoProps) {
  const Video = di?.Video ?? DefaultVideo;
  const NoWebkitOverflowScrolling = di?.NoWebkitOverflowScrolling ?? DefaultNoWebkitOverflowScrolling;
  return (
    <article className={styles.page}>
      <section className={styles.card}>
        <NoWebkitOverflowScrolling />
        <div className={styles.videoContainer}>
          <Video type={watch.type} watch={watch} autoplay={false} />
          <div className={styles.state}>
            <DDSBodyText className={styles.statusText}>
              <Trans>Video is playing on your phone</Trans>
            </DDSBodyText>
            {canPlayOnComputer && (
              <DDSButton
                variant="tertiary"
                data-name="phone_watch_video:mojo_show_video_play_on_computer"
                onClick={() => {
                  onPlayOnComputer();
                }}
              >
                <Trans>Play on computer instead</Trans>
              </DDSButton>
            )}
            {!canPlayOnComputer && (
              <Link to="/apps/help/what-is-dojocast" className={styles.helpLink}>
                <Trans>Play on computer instead</Trans>
              </Link>
            )}
          </div>
        </div>
      </section>
    </article>
  );
}

export default PhoneWatchVideo;
